var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CButton',{staticClass:"!tw-mr-1 tw-text-sm",attrs:{"href":_vm.showOiriginal ? _vm.newClassifiedUrl : _vm.legacyUrlService.offerBtnLink(),"variant":"offer","size":"sm"}},[_c('CDynamicIcon',{attrs:{"icon":_vm.legacyUrlService.offerBtnIcon()}}),_vm._v("\n  "+_vm._s(_vm.showOiriginal
      ? _vm.$t('create new classified')
      : _vm.legacyUrlService.offerBtnText())+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }